package com.macrofocus.eflux.ui

import com.macrofocus.eflux.time.TimeTracker
import i18next.invoke
import i18next.useTranslation
import mui.icons.material.RestoreTwoTone
import mui.icons.material.UpdateTwoTone
import mui.material.*
import mui.system.sx
import org.mkui.react.useProperty
import react.FC
import react.PropsWithChildren
import react.ReactNode
import web.cssom.NamedColor
import web.cssom.px

external interface LiveSwitchProps : PropsWithChildren {
    var timeTracker: TimeTracker
    var badge: Boolean
}

val LiveSwitch = FC<LiveSwitchProps> { props ->
    val (t, _) = useTranslation()

    val (getLive, setLive) = useProperty(props.timeTracker.liveProperty)
    val (new, _) = useProperty(props.timeTracker.newProperty)

    mui.material.Tooltip {
        title = if (getLive) ReactNode(t("appMenu.configuration.live.replay")) else ReactNode(t("appMenu.configuration.live.live"))
        placement = TooltipPlacement.top

        IconButton {
//            size = Size.small
            ariaLabel = "live"

            sx {
//                background = if (!getLive) NamedColor.indianred else NamedColor.lightsteelblue
                marginRight = 5.px
            }

            onClick = { _ ->
                if (!getLive) {
                    props.timeTracker.liveTurnedOn()
                } else {
                    props.timeTracker.replayTurnedOn()
                }
            }

            if(props.badge) {
                Badge {
                    color = BadgeColor.primary
                    variant = BadgeVariant.dot
                    invisible = !new
                    badgeContent = if (new) ReactNode(" ") else null

                    if (!getLive) UpdateTwoTone { // LiveTvTwoTone
                        sx {
                            color = NamedColor.indianred
                        }
                    } else RestoreTwoTone {
                        sx {
                            color = NamedColor.steelblue
                        }
                    }
                }
            } else {
                if (!getLive) UpdateTwoTone { // LiveTvTwoTone
                    sx {
                        color = NamedColor.indianred
                    }
                } else RestoreTwoTone {
                    sx {
                        color = NamedColor.steelblue
                    }
                }
            }
        }
    }
}